import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { UserCurrencyType } from '../../enums/users/user-currency-type.enum';
import { UserCurrencyTransactionType } from '../../enums/users/user-currency-transaction-type.enum';

@JsonObject('UserCurrencyTransaction')
export class UserCurrencyTransaction {

  @JsonProperty('currency_type', Number)
  currencyType: UserCurrencyType = UserCurrencyType.None;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;

  @JsonProperty('currency_account_amount_final', Number)
  currencyAccountAmountFinal: number = 0;

  @JsonProperty('transaction_type', Number)
  transactionType: UserCurrencyTransactionType = UserCurrencyTransactionType.None;

  @JsonProperty('created_at_timestamp', Number)
  createdAtTimestamp: number = 0;

  @JsonProperty('transaction_shop_package_id', Any)
  transactionShopPackageId: string | null = null;

  @JsonProperty('transaction_shop_price', Number)
  transactionShopPrice: number = 0;
}
